/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-email-recipient-modal-component.ts
 *
 * Created by randysorensen on 10/12/17.
 */

'use strict';

function PartnerEmailRecipientModalController (this: JS5Object, _: JS5Object, NetworkViewService: JS5Object) {

	//=================//
	// Lifecycle Hooks //
	//=================//

	this.$onInit = () => {
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.loadingIndicator.show = true;
		NetworkViewService.getSearchViewData({fetchLimit: 0})
			.then((networksList: JS5Object[]) => {
				this.availableNetworks = networksList;
				this.loadingIndicator.show = false;
			});

		this.recipientObject = _.cloneDeep(this.resolve.recipientObject);
	};


	//================//
	// Template Logic //
	//================//

	this.onOk = (): void => {
		this.close({
			$value: this.recipientObject,
		});
	};
}

angular
.module('prism-ui.partner')
.component(
	'partnerEmailRecipientModal',
	{
		controller: PartnerEmailRecipientModalController,
		templateUrl: 'components/visual/emailRecipientsList/modals/partner-email-recipient-modal-template.html',
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&',
		},
	}
);
